import React from "react"
import {Input} from "antd"
import {TextAreaProps} from "antd/es/input"
import s from "./textarea.module.scss"

const {TextArea} = Input

interface PropsTypes extends TextAreaProps {
    isInvalid?: any
    showErrorMessage?: boolean
    containerStyle?: any
}

export const FormTextarea: React.FC<PropsTypes> = ({isInvalid, showErrorMessage = true, containerStyle, ...props}) => {
    return (
        <div className="form-input" style={containerStyle}>
            <div style={{position: 'relative'}} >
                <TextArea status={isInvalid ? 'error' : ''}
                          className={s.textarea}
                          {...props}
                />
                {
                    props.value
                        ? <span style={{position: 'absolute', top: 1, left: 12, fontSize: 11, zIndex: 100, fontWeight: 600, color: '#8c8c8c', opacity: 0.5}}>
                    {props.placeholder}</span>
                        : null
                }
            </div>
            {isInvalid && showErrorMessage ? <div className="input-error-visible">{isInvalid}</div> : null}
        </div>
    )
}